import React, { useState, useEffect } from 'react';
import { Avatar, Box, Grid, TextField, MenuItem, List, Popover, ListItem, ListItemText, Modal, FormControl, IconButton, Select, InputLabelCheckbox, Checkbox, FormControlLabel, Button, InputLabel, InputAdornment, Tab, Tabs, ListItemButton, DialogContent, DialogTitle, Dialog } from '@mui/material';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import CancelIcon from '@mui/icons-material/Cancel';
import { styled } from '@mui/material/styles';
import currencyCodes from 'currency-codes';
import { useProfileContext } from '../../../ProfileDetailContext'
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import { servicesContext } from '../../../Utilities/ServicesContext';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { ReactComponent as OutlinedPlusIcon } from '../../../../Assets/img/icons/expand-plus-outlined-figma.svg'
import { ReactComponent as OutlinedMinusIcon } from '../../../../Assets/img/icons/collapse-minus-outlined-figma.svg'
import { ReactComponent as SearchIcon } from '../../../../Assets/img/icons/search-icon-figma.svg'
import { ReactComponent as AiLogo } from "../../../../Assets/img/icons/ai-rewrite-logo.svg";
import DeleteIcon from '@mui/icons-material/Delete';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

import AddRecommendation from './AddRecommendation';
import AddProject from './AddProject'
import AddAwards from './AddAwards';
import { DeleteLightBox } from '../ProfessionalProfile';
import useApi from '../../../Utilities/useAPI';
import PreviewFileItem from '../../../Utilities/PreviewFileItem';
import { MAX_DESC_LENGTH } from '../../../../config/constant';
import { deleteServiceReducer, getServiceReducer, postServiceBlobReducer } from '../../../../Redux/Reducers/ProfileReducer';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useQuantityContext } from '../../../QuantityContext';

const AddSection = ({ OpenAddMoreSection,
    setOpenAddMoreSection,
    isEditServices,
    // OtherNewSections,
    // setOtherNewSections,
    // setOpenLanguage,
    // setOpenModalSkills,
    initialTab,
    handleGenerateDescription,
    handleSuccess,
    handleFailure,
    openSnackbar,
    servicesDetails }) => {

    const { projectDetails, updateAttachments, setEditProjectIndex, updateProjectDetails, resetProjectDetails, handleSaveForProject, awardDetails, updateAwardsDetails, setAwardEditIndex, updateAwardsAttachments, handleSaveForAwards,
        services, setServices, handleInputChangeServices, updateServicesAttachments, removeServiceAttachments, resetServices, setAddSection } = useProfileContext();

    const { callApiFunction } = useApi();

    const handleProjectInputChange = (fieldName) => (event) => {
        const newValue = event.target.value;
        updateProjectDetails({ [fieldName]: newValue });
    };

    // console.log("servicesDetailsservicesDetails ", servicesDetails, "isEditServices", OpenAddMoreSection);
    const handleAwardInputChange = (fieldName) => (event) => {
        const newValue = event.target.value;
        updateAwardsDetails({ [fieldName]: newValue });
    };

    const dispatch = useDispatch();
    const ServiceBlobData = useSelector((state) => state?.ProfileArray?.serviceBlob);
    const [activeMenu, setActiveMenu] = useState('Recommended');
    const [handleProjectLightBox, sethandleProjectLightBox] = useState(false);
    const [addRecommendation, setaddRecommendation] = useState(false);
    const [addAwards, setaddAwards] = useState(false);
    const [newServices, setnewServices] = useState('');
    // const [currency, setCurrency] = useState('INR');
    // const [rate, setRate] = useState('');
    const [serviceDelete, setServiceDelete] = useState(false);

    const { handleInfo } = useQuantityContext();
    // const isServiceEditing = extractedData?.id !== '' || isEditServices === true ? true : false;

    // const handleCurrencyChange = (selectedOption) => {
    //     setCurrency(selectedOption);
    // };

    // const handleRateChange = (event) => {
    //     setRate(event.target.value);
    // };

    const handleMenuClick = (event, menu) => {
        setActiveMenu(menu);
    };

    // const handleAddServices = (skill) => {
    //     if (skill.trim() === '') {
    //         return;
    //     }
    //     console.log("Services ", skill, "PALLED", currentServices?.yourservices);
    //     if (currentServices?.yourservices?.length + 1 > 10) {
    //         openSnackbar("You can only add up to 10 services!", "info", 7000);
    //         return;
    //     }
    //     setnewServices('');
    //     const isSkillSelected = currentServices?.yourservices.includes(skill);
    //     // If the skill is selected, remove it from the array
    //     if (isSkillSelected) {
    //         const updatedServices = currentServices.yourservices.filter((selectedSkill) => selectedSkill !== skill);
    //         setCurrentServices(prevState => ({ ...prevState, yourservices: updatedServices }));
    //     } else {
    //         setCurrentServices(prevState => ({ ...prevState, yourservices: [...prevState.yourservices, skill] }));
    //     }
    // };


    const handleAddServices = (skill) => {
        if (!skill || skill.trim() === '') {
            return;
        }

        // console.log("Before Update:", currentServices?.yourservices);

        // If the skill already exists, remove it; otherwise, add it
        setCurrentServices((prevState) => {
            const isSkillSelected = prevState.yourservices.includes(skill);
            const updatedServices = isSkillSelected
                ? prevState.yourservices.filter(selectedSkill => selectedSkill !== skill) // Remove if already selected
                : [...prevState.yourservices, skill]; // Add if not selected

            return {
                ...prevState,
                yourservices: updatedServices, // Properly updating the array
            };
        });

        // console.log("After Update:", currentServices?.yourservices);
    };

    const [isChecked, setIsChecked] = useState(false);
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');

    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };

    // const months = [
    //     'January', 'February', 'March', 'April', 'May', 'June',
    //     'July', 'August', 'September', 'October', 'November', 'December'
    // ];
    // const currentYear = new Date().getFullYear();
    // const years = Array.from(
    //     { length: currentYear - 1970 + 1 },
    //     (_, index) => currentYear - index
    // );

    //for Future Reference - to add fields into the Main     
    // const addProject = (newProject) => {
    //     setOtherNewSections(prevProfile => ({
    //       ...prevProfile,
    //       projects: [...prevProfile.projects, newProject]
    //     }));
    //   };

    // const addRecommendation = (newRecommendation) => {
    //     setOtherNewSections(prevProfile => ({
    //       ...prevProfile,
    //       recommendations: [...prevProfile.recommendations, newRecommendation]
    //     }));
    //   };

    const [AddLinkService, setAddLinkService] = useState(false);
    const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
    const [OpenAddServices, setOpenAddServices] = useState(false);

    const handleAddProjectClick = () => {
        resetProjectDetails();
        setEditProjectIndex(null);
        sethandleProjectLightBox(true);
        setOpenAddMoreSection(false);
    }

    const handleAddAwardsClick = () => {
        setAwardEditIndex(null);
        setaddAwards(true);
        setOpenAddMoreSection(false)
    }

    useEffect(() => {
        if (OpenAddMoreSection) {
            setActiveMenu(initialTab);
        }
    }, [OpenAddMoreSection, initialTab]);

    const extractedData = servicesDetails[0];
    // console.log("extractedDataextractedData", extractedData);

    const isServiceEditing = extractedData?.id !== '' || isEditServices === true ? true : false;
    // Local Services State
    const [currentServices, setCurrentServices] = useState({

        id: extractedData?.id || null,
        yourservices: Array.isArray(extractedData?.services_info)
            ? extractedData?.services_info
            : JSON.parse(extractedData?.services_info || "[]"),
        servicesDetails: extractedData?.about_services || "",
        workLocation: extractedData?.location || "",
        remote: extractedData?.is_available_remote ? "Remote" : "",
        dayStart: extractedData?.start_day || "",
        dayEnd: extractedData?.end_day || "",
        workStart: extractedData?.starting_hour || "",
        workEnd: extractedData?.ending_hour || "",
        currency: extractedData?.currency || "",
        hourRate: extractedData?.hourly_rate || "",
        serviceAttachments: extractedData?.attachments || [],
    });

    // console.log("currentServices", currentServices);


    const [serviceError, setServiceError] = useState({
        workLocation: false,
        onlyEndDay: false,
        onlyEndTime: false
    })

    // Syncing Local State with Global State
    // useEffect(() => {
    //     setCurrentServices(servicesDetails);

    // }, [servicesDetails])



    const handleInputChangeCurrent = (e) => {
        const { name, value } = e.target;
        setCurrentServices((prevState) => ({
            ...prevState,
            [name]: value,
        }));
        if (name === "dayStart" && serviceError.onlyEndDay) {
            setServiceError((prev) => ({ ...prev, onlyEndDay: false }))
        }
        if (name === "workStart" && serviceError.onlyEndTime) {
            setServiceError((prev) => ({ ...prev, onlyEndTime: false }))
        }
    };

    const updateCurrentServices = (updatedField) => {
        //with both Key and Pair
        setCurrentServices((prevDetails) => ({
            ...prevDetails,
            ...updatedField,
        }));
    };

    const updateCurrentServicesAttachments = (newAttachment) => {
        const attachmentWithId = { ...newAttachment, id: uuidv4() };

        setCurrentServices((prevState) => ({
            ...prevState,
            serviceAttachments: Array.isArray(prevState.serviceAttachments)
                ? [...prevState.serviceAttachments, attachmentWithId]
                : [attachmentWithId], // Initialize as an array if undefined
        }));
        // setCurrentServices((prevState) => ({
        //     ...prevState,
        //     serviceAttachments: [...prevState.serviceAttachments, attachmentWithId],
        // }));
    };

    const removeCurrentServicesAttachments = (id) => {
        // console.log('Entered removeServiceAttachments to delete id', id, services?.serviceAttachments);
        setCurrentServices((prevState) => ({
            ...prevState,
            serviceAttachments: prevState.serviceAttachments.map((attachment) =>
                attachment?.id === id ? { ...attachment, toBeDeleted: true } : attachment
            ),
        }));
    };

    const resetCurrentServices = () => {
        setCurrentServices({
            id: '',
            yourservices: [],
            servicesDetails: '',
            workLocation: '',
            remote: '',
            dayStart: '',
            dayEnd: '',
            workStart: '',
            workEnd: '',
            currency: 'INR',
            hourRate: 0,
            serviceAttachments: [],
            removedAttachments: []
        })
    }

    const validateServiceForm = () => {
        const errors = {
            noServicesAdded: currentServices?.yourservices?.length === 0,
            workLocation: !currentServices.workLocation && !currentServices.remote, // True if neither location is selected
            onlyEndDay: !currentServices.dayStart && currentServices.dayEnd, // True if only `dayEnd` is filled without `dayStart`
            onlyEndTime: !currentServices.workStart && currentServices.workEnd, // True if only `workEnd` is filled without `withoutStart`
        };
        setServiceError(errors);

        // If there are any errors, return false
        return !Object.values(errors).includes(true);
    };
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredServices, setFilteredServices] = useState([]);
    useEffect(() => {
        if (searchQuery) {
            const results = servicesContext
                .flatMap(category => category.skills)  // Get a flat array of all skills
                .filter(skill => skill.toLowerCase().includes(searchQuery.toLowerCase()));

            setFilteredServices(results);
        } else {
            setFilteredServices([]);
        }
    }, [searchQuery]);

    // API Calling Functions
    const handleSaveServices = async () => {
        if (!validateServiceForm()) {
            return; // Stop if validation fails
        }

        // Clear errors if validation succeeds
        setServiceError({ workLocation: false, onlyEndDay: false });

        const endpoint = 'servicesCreateUpdate';
        const { yourservices, servicesDetails, workLocation, remote, dayStart, dayEnd, workStart, workEnd, currency, hourRate, serviceAttachments } = currentServices;
        const documents = serviceAttachments
            ?.filter((attachment) => !attachment.toBeDeleted)
            ?.map((attachment) => ({
                document_name: attachment?.name || attachment?.document_name,
                document_link: attachment?.data || attachment?.document_url,
                document_type: attachment?.type || attachment?.document_type,
                document_meta: {
                    document_size: attachment?.size || attachment?.size
                },
                is_verified: false,
                is_public: false
            }));


        console.log("file DATA", currentServices);

        const formData = new FormData();

        const id = OpenAddMoreSection ? extractedData?.id || '' : '';
        const fields = {
            id,
            about_services: servicesDetails,
            location: workLocation,
            is_available_remote: remote === 'Remote' ? 1 : 0,
            start_day: dayStart,
            end_day: dayEnd,
            starting_hour: workStart,
            ending_hour: workEnd,
            currency,
            hourly_rate: hourRate || 0
        };

        Object.entries(fields).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== "") {
                formData.append(key, value);
            }
        });
        const parsedServices = Array.isArray(yourservices) ? yourservices : [];

        parsedServices.forEach(service => {
            formData.append('services_info[]', service);
        });

        // Attach files if available
        if (documents?.length > 0) {
            setLoading(true);
            handleInfo("Please wait to complete the process")
            for (let i = 0; i < documents?.length; i++) {
                // const file = documents[i];
                try {

                    const fileName = documents[i].document_name || "default_name";
                    const fileType = documents[i].document_type;
                    const fileSize = documents[i].document_meta?.document_size; // Get size from JSON

                    const documentLink = documents[i].document_link;

                    console.log(`File: ${fileName}, Size: ${fileSize}, Link: ${documentLink}`);

                    // if (documentLink.startsWith("blob:http://localhost:3000/")) {

                    if (fileType === "url") {
                        const websiteLinks = {
                            "document_name": documents[i]?.document_name,
                            "document_link": documents[i]?.document_link,
                            "document_type": documents[i]?.document_type,
                            "document_meta": {
                                "document_size": documents[i]?.document_meta?.document_size || 0
                            },
                            "is_verified": documents[i]?.is_verified,
                            "is_public": documents[i]?.is_public
                        };

                        formData.append("website_links[]", JSON.stringify(websiteLinks));
                    } else {
                        const response = await fetch(documentLink);
                        const blob = await response.blob();

                        const file = new File([blob], fileName, { type: fileType });

                        formData.append("attachments", blob, fileName);
                    }
                } catch (error) {

                    console.error("Error fetching attachment:", error);
                } finally {
                    setLoading(false);
                }
            }
            // setLoading(false);
        }

        try {
            // setLoading(true);
            const response = await dispatch(postServiceBlobReducer(formData));
            // console.log("SERVICESS SERVICESS", response);
            if (response?.payload?.statusCode === 200) {

                // console.log("Service Blob ID", ServiceBlobData?.id);
                await dispatch(getServiceReducer());
                // if()
                // const newId = ServiceBlobData?.id;
                // setExtractedData([newId]);
                // Update state sequentially
                // setCurrentServices((prevServices) => ({
                //     ...prevServices,
                //     id: newId,
                // }));

                // setServices((prevServices) => ({
                //     ...prevServices,
                //     id: newId,
                // }));

                setOpenAddMoreSection(false);
                handleSuccess();

                // setAddSection((prevState) => ({
                //     ...prevState,
                //     professionalService: true,
                // }));
            }

        } catch (error) {
            console.log("Error Saving Services Details: ", error);
            handleFailure();
        } finally {
            // setLoading(false);
        }
    }

    const handleDeleteService = async () => {
        const endpoint = 'servicesDelete';
        const { id } = currentServices;
        const params = { id };
        try {
            setLoading(true);
            // const response = await callApiFunction(endpoint, params);
            const response = await dispatch(deleteServiceReducer(id));
            if (response?.payload?.statusCode === 200) {

                await dispatch(getServiceReducer());
                resetCurrentServices();
                resetServices();
                // setAddSection((prevState) => ({
                //     ...prevState,
                //     professionalService: true,
                // }));
                setServiceDelete(false);
                handleSuccess('', 'Delete');

            } else {
                console.log('Could not DELETE Services', response);
                handleFailure('', 'Delete');
            }
        } catch (error) {
            console.log('TRY for DELETE failed', error, params);
            console.log('Services state', services);
            handleFailure('', 'Delete');
        } finally {
            setLoading(false);
        }
    }

    const serviceList = Array.isArray(currentServices?.yourservices)
        ? currentServices.yourservices
        : (typeof currentServices.yourservices === "string"
            ? currentServices.yourservices.split(",").map(s => s.trim())
            : []);


    return (
        <>
            {OpenAddMoreSection &&
                <div className="lightbox-overlay">
                    <div className="lightbox-content-2 p-0">
                        <div className="active-component-container add-section-modal mt-0">
                            <>
                                <div className='px-4 pt-4 pb-2'>
                                    <div className='profile-modal-heading1 text-left mb-2'>Add Section</div>
                                    <div className='heading-fav-content text-start'>Add Multiple Sections to your Profile</div>
                                    <IconButton sx={{ position: "absolute", top: "1rem", right: "1rem" }} onClick={() => { setOpenAddMoreSection(false) }}>
                                        <CloseRoundedIcon />
                                    </IconButton>
                                </div>

                                <div className="px-2 menu">
                                    <Tabs
                                        value={activeMenu}
                                        onChange={handleMenuClick}
                                        aria-label="Profile Tabs"
                                        variant="scrollable"
                                        scrollButtons="auto"
                                        className='custom-profile-tabs'
                                        selectionFollowsFocus
                                    >
                                        <Tab
                                            label="Recommended"
                                            value="Recommended"
                                        />
                                        <Tab
                                            label="Add Services"
                                            value="Add Services"
                                        />
                                    </Tabs>
                                </div>
                                <div className="rsuite-container">
                                    <div className='content-for-Email'>
                                        {activeMenu === 'Recommended' && (
                                            <div className="menu-content m-0 p-0">
                                                <ul className="custom-list">
                                                    <li className="custom-item" onClick={handleAddProjectClick}>Add Project</li>
                                                    <li className="custom-item" onClick={() => { setaddRecommendation(true); setOpenAddMoreSection(false); }}>Add Recommendations</li>
                                                    <li className="custom-item" onClick={handleAddAwardsClick}>Add Honors & Awards</li>
                                                    {/* <li className="custom-item" onClick={() => { setOpenLanguage(true); setOpenAddMoreSection(false); }}>Add Languages</li>
                                                    <li className="custom-item" onClick={() => { setOpenModalSkills(true); setOpenAddMoreSection(false); }}>Add Skills</li> */}
                                                </ul>
                                            </div>
                                        )}
                                        {activeMenu === 'Add Services' && (
                                            <div className="menu-content px-4 py-3 text-start">
                                                <div className="text-start">
                                                    <div className="profile-modal-heading1 mb-2">Set up your Services</div>
                                                    <div className="prof-profile-tab-actions justify-content-start">
                                                        <div className="flex-center" onClick={() => { setOpenAddServices(true); }}>
                                                            <IconButton>
                                                                <AddCircleRoundedIcon />
                                                            </IconButton>
                                                            <div className="sort-icons-cont fw-bold">Add Services</div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="mb-3">
                                                    <div>Services Provided: *</div>
                                                    {currentServices?.yourservices?.length !== 0 &&
                                                        <div className="skills-list-professional mt-0">
                                                            {serviceList.map((skill, index) => (
                                                                <SkillItem key={index} label={skill} isEdit={true} onAdd={handleAddServices} />
                                                            ))}
                                                        </div>
                                                    }
                                                </div>
                                                <TextField
                                                    multiline
                                                    rows={2}
                                                    name="servicesDetails"
                                                    label="About your Services"
                                                    placeholder="Write about your Services (500 characters Maximum)"
                                                    autoComplete="off"
                                                    variant="outlined"
                                                    fullWidth
                                                    inputProps={{ maxLength: MAX_DESC_LENGTH }}
                                                    value={currentServices?.servicesDetails}
                                                    onChange={handleInputChangeCurrent}
                                                    className='mt-1'
                                                />
                                                <div className="d-flex justify-content-end align-items-start my-2">
                                                    {/* <div className="invite-modal-subtitle">Enable AI Generation with minimum 15 words</div> */}
                                                    <Button
                                                        variant="outlined"
                                                        sx={{ color: "#0044C6" }}
                                                        className="ai-rewrite-button"
                                                        onClick={() => handleGenerateDescription(
                                                            {
                                                                services: currentServices?.yourservices,
                                                                companyName: currentServices?.companyName,
                                                                location: currentServices?.workLocation,
                                                                isRemote: currentServices?.remote,
                                                                description: currentServices?.servicesDetails,
                                                            },
                                                            "services",
                                                            "servicesDetails",
                                                            updateCurrentServices
                                                        )
                                                        }
                                                        disabled={currentServices?.yourservices?.length < 1}
                                                        startIcon={<AiLogo />}
                                                    >
                                                        Generate
                                                    </Button>
                                                </div>

                                                <div className="my-3">
                                                    <div className="profile-modal-heading1 text-left">Work Location *</div>
                                                    <div className="mt-1 d-flex align-items-center">
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    name="workLocation"
                                                                    checked={currentServices?.workLocation === "Bengaluru, Karnataka"}
                                                                    onChange={() => {
                                                                        setCurrentServices((prev) => ({
                                                                            ...prev,
                                                                            workLocation: prev.workLocation === "Bengaluru, Karnataka" ? '' : "Bengaluru, Karnataka",
                                                                        }));
                                                                        setServiceError((prev) => ({ ...prev, workLocation: false }))
                                                                    }
                                                                    }
                                                                    color="primary"
                                                                />
                                                            }
                                                            label="Bengaluru, Karnataka"
                                                        />
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    name="remote"
                                                                    checked={currentServices?.remote === "Remote"}
                                                                    onChange={() => {
                                                                        setCurrentServices((prev) => ({
                                                                            ...prev,
                                                                            remote: prev.remote === "Remote" ? '' : "Remote",
                                                                        }))
                                                                        setServiceError((prev) => ({ ...prev, workLocation: false }))
                                                                    }
                                                                    }
                                                                    color="primary"
                                                                />
                                                            }
                                                            label="I am available to work remotely"
                                                        />
                                                    </div>
                                                    {serviceError.workLocation && (
                                                        <div className='error-text'>
                                                            * At least one option must be selected in Work Location
                                                        </div>
                                                    )}
                                                </div>

                                                <div className='my-3'>
                                                    <div className="profile-modal-heading1 text-left">Working days</div>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={6}>
                                                            <FormControl fullWidth margin="normal">
                                                                <InputLabel id="start-day-label">Start Day</InputLabel>
                                                                <Select
                                                                    name="dayStart"
                                                                    labelId="start-day-label"
                                                                    value={currentServices?.dayStart}
                                                                    onChange={handleInputChangeCurrent}
                                                                    label="Start Day"
                                                                >
                                                                    <MenuItem key='empty' value={""}><i>Select</i></MenuItem>
                                                                    {daysOfWeek.map((day) => (
                                                                        <MenuItem key={day} value={day}>
                                                                            {day}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            </FormControl>
                                                        </Grid>

                                                        <Grid item xs={6}>
                                                            <FormControl fullWidth margin="normal">
                                                                <InputLabel id="end-day-label">End Day</InputLabel>
                                                                <Select
                                                                    name="dayEnd"
                                                                    labelId="end-day-label"
                                                                    value={currentServices?.dayEnd}
                                                                    onChange={handleInputChangeCurrent}
                                                                    label="End Day"
                                                                >
                                                                    <MenuItem key='empty' value={""}><i>Select</i></MenuItem>
                                                                    {daysOfWeek.map((day) => (
                                                                        <MenuItem key={day} value={day}>
                                                                            {day}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            </FormControl>
                                                        </Grid>
                                                    </Grid>
                                                    {serviceError?.onlyEndDay && (
                                                        <div className='error-text'>
                                                            * End Day cannot be selected without Start Day.
                                                        </div>
                                                    )}
                                                </div>

                                                <div className='my-3'>
                                                    <div className="profile-modal-heading1 text-left mb-2">Working Hours</div>
                                                    <div className="d-flex gap-3">
                                                        <div className="flex-center gap-2">
                                                            <div className='time-label'>Start</div>
                                                            <TextField
                                                                type="time"
                                                                name="workStart"
                                                                value={currentServices?.workStart}
                                                                onChange={handleInputChangeCurrent}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                                inputProps={{
                                                                    step: 300, // 5 min
                                                                }}
                                                                className="time-field"
                                                            />
                                                        </div>
                                                        <div className="flex-center gap-2">
                                                            <div className='time-label'>End</div>
                                                            <TextField
                                                                type="time"
                                                                name="workEnd"
                                                                value={currentServices?.workEnd}
                                                                onChange={handleInputChangeCurrent}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                                inputProps={{
                                                                    step: 300, // 5 min
                                                                }}
                                                                className="time-field"
                                                            />
                                                        </div>
                                                    </div>
                                                    {serviceError.onlyEndTime && (
                                                        <div className='error-text'>
                                                            * Ending Time cannot be selected without Starting Time.
                                                        </div>
                                                    )}
                                                </div>

                                                <div className='my-3'>
                                                    <div className="profile-modal-heading1 text-left mb-1">Pricing</div>
                                                    <p className='text-left subtitle_services_section m-0 p-0 mb-2'>Starting at</p>
                                                    <div className="d-flex gap-3">
                                                        <div className="d-flex align-items-start flex-column">
                                                            <div className="time-label">Currency</div>
                                                            <CurrencyDropdown name="currency" value={currentServices?.currency} onChange={handleInputChangeCurrent} />
                                                        </div>
                                                        <div className="d-flex align-items-start flex-column">
                                                            <div className="time-label">Hourly rate</div>
                                                            <input
                                                                className='currency-field form-control'
                                                                name="hourRate"
                                                                value={currentServices?.hourRate}
                                                                onChange={handleInputChangeCurrent}
                                                                type='number'
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='my-3 text-left'>
                                                    <div className="profile-modal-heading1 text-left mb-1">Attachments</div>
                                                    <p className='text-left subtitle_services_section m-0 p-0 mb-2'>Upload Media like images, documents, sites or presentations</p>
                                                    {currentServices?.serviceAttachments
                                                        ?.filter((attachment) => !attachment?.toBeDeleted)
                                                        ?.map((attachment, index) => (
                                                            <div key={index} className="add-project-modal my-3">
                                                                {typeof attachment === 'string' ? (
                                                                    <div className="design-lighter-textNew">{attachment}</div>
                                                                ) : (
                                                                    <div className="d-flex align-items-center gap-2">
                                                                        <div className="Documents-Attachments">
                                                                            <PreviewFileItem file={attachment} fontColor="#00000099" />
                                                                        </div>
                                                                        <IconButton onClick={() => removeCurrentServicesAttachments(attachment.id)}>
                                                                            <DeleteIcon />
                                                                        </IconButton >
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    <SkillItemForServices
                                                        maxSize={5000000}
                                                        className="text-left"
                                                        updateAttachments={updateCurrentServicesAttachments}
                                                    />
                                                </div>
                                                {isServiceEditing ? (
                                                    <div className='mt-3 d-flex justify-content-between'>
                                                        <Button variant="outlined" sx={{ color: "#0044C6" }} onClick={() => { setServiceDelete(true) }}>Delete</Button>
                                                        <Button
                                                            variant="contained"
                                                            sx={{ backgroundColor: "#0044C6" }}
                                                            disabled={!currentServices?.servicesDetails || currentServices?.yourservices?.length === 0}
                                                            onClick={handleSaveServices}
                                                        >
                                                            Save
                                                        </Button>
                                                    </div>
                                                ) : (
                                                    <div className='mt-3 d-flex justify-content-end'>
                                                        <Button variant="contained" sx={{ backgroundColor: "#0044C6" }} disabled={currentServices?.yourservices?.length === 0} onClick={handleSaveServices}>Save</Button>
                                                    </div>
                                                )}

                                            </div>
                                        )}
                                    </div>
                                </div>
                            </>
                        </div>
                    </div>
                </div>}


            <Dialog
                open={OpenAddServices}
                onClose={() => { setOpenAddServices(false) }}
                fullWidth
                className="custom-dialog-font"
            >
                <DialogTitle>
                    <div>
                        {/* <IconButton className="modal-close-button" onClick={onClose}>
                            <CloseRoundedIcon />
                        </IconButton> */}
                        <div className='profile-modal-heading1 mb-2'>Add Services</div>
                        <div className='heading-fav-content'>Select services from the list</div>
                    </div>

                    <div className="Search-add-people mt-3" style={{ position: "relative" }}>
                        <TextField
                            value={searchQuery}
                            onChange={(event) => setSearchQuery(event.target.value)}
                            placeholder="Search"
                            variant="outlined"
                            size="small"
                            className="searchBox-addPeople"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        {filteredServices?.length !== 0 && (
                            <List className='recommenders-list' sx={{ position: "absolute", backgroundColor: "white" }}>
                                {filteredServices.map((service) => (
                                    <ListItemButton className='gap-2' key={service.id} onClick={() => { handleAddServices(service); setSearchQuery('') }}>
                                        <ListItemText primary={service} />
                                    </ListItemButton>
                                ))}
                            </List>
                        )}
                    </div>
                </DialogTitle>

                <DialogContent dividers>

                    {currentServices?.yourservices?.length !== 0 && (
                        <div className='mb-3'>
                            <div className='profile-modal-heading1 mb-2'>Selected Skills</div>
                            <div className="skills-list-professional mb-2">
                                {serviceList.map((skill, index) => (
                                    <SkillItem key={skill} label={skill} isEdit={true} onAdd={handleAddServices} />
                                ))}
                            </div>
                        </div>
                    )}

                    <SkillsAccordion
                        sections={servicesContext}
                        selectedSkills={currentServices?.yourservices}
                        handleAddSkill={handleAddServices}
                    />
                </DialogContent>

                <div className='d-flex align-items-center justify-content-end gap-3 my-4 mx-4'>
                    {/* <Button onClick={onClose} color="secondary">Cancel</Button> */}
                    <Button variant='contained' sx={{ backgroundColor: "#0044C6" }} onClick={() => { setOpenAddServices(false) }}>Done</Button>
                </div>
            </Dialog>

            {/* {OpenAddServices &&
                <div className="lightbox-overlay">
                    <div className="lightbox-content-2 p-0">
                        <>
                            <div className='p-4 profile-modal-title-content'>
                                <IconButton className="modal-close-button p-0" onClick={() => { setOpenAddServices(false) }}><CloseRoundedIcon /></IconButton>
                                <div className='profile-modal-heading1 text-left mb-2'>Add Services</div>
                                <div className='heading-fav-content text-left'>Add Multiple Section to your Profile</div>

                                <div className="Search-add-people mt-3">
                                    <TextField
                                        value={searchQuery}
                                        onChange={(event) => setSearchQuery(event.target.value)}
                                        placeholder="Search"
                                        variant="outlined"  // Set a valid variant
                                        size="small"
                                        className="searchBox-addPeople"
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="py-3 px-4">
                                {currentServices.yourservices?.length !== 0 && (
                                    <div className='mb-3'>
                                        <div className='profile-modal-heading1 mb-2 text-left'> Selected Skills </div>
                                        <div className="skills-list-professional mb-2">
                                            {currentServices.yourservices.map((skill, index) => (
                                                <SkillItem key={skill} label={skill} isEdit={true} onAdd={handleAddServices} />
                                            ))}
                                        </div>
                                    </div>
                                )}
                                <SkillsAccordion
                                    sections={servicesContext}
                                    selectedSkills={currentServices.yourservices}
                                    handleAddSkill={handleAddServices}
                                />
                            </div>
                        </>
                    </div>
                </div>} */}

            {handleProjectLightBox &&
                <AddProject
                    open={handleProjectLightBox}
                    onClose={() => { sethandleProjectLightBox(false); setOpenAddMoreSection(true) }}
                    isEditing={false}
                    editProjectIndex={null}
                    handleGenerateDescription={handleGenerateDescription}
                    handleSuccess={handleSuccess}
                    handleFailure={handleFailure}
                />
            }

            {addRecommendation &&
                <div className="lightbox-overlay">
                    <div className="lightbox-content-2 p-0" style={{ width: "40%" }}>
                        <AddRecommendation setaddRecommendation={setaddRecommendation} setOpenAddMoreSection={setOpenAddMoreSection} />
                    </div>
                </div>
            }

            {addAwards &&
                <AddAwards
                    open={addAwards}
                    onClose={() => { setaddAwards(false); setOpenAddMoreSection(true) }}
                    isEditing={false}
                    editAwardIndex={null}
                    handleGenerateDescription={handleGenerateDescription}
                    handleSuccess={handleSuccess}
                    handleFailure={handleFailure}
                />
            }

            {serviceDelete &&
                <DeleteLightBox Title="Services" Label="Do you really want to your Services?"
                    clearFields={undefined} LightBoxCloseFunction={setServiceDelete} DeleteFunction={handleDeleteService} />
            }

        </>
    );
};

// const SkillItem2 = ({ label, selectedSkills, onAdd }) => (
//     <div onClick={() => onAdd(label)}>{label}</div>
// );
const SkillBox2 = styled(Box)({
    border: "1px solid #D9D9D9",
    borderRadius: 50,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "5px 10px",
    margin: "6px",
    gap: "4px"
});

function SkillItem2({ label, selectedSkills, onAdd }) {
    const isSkillSelected = selectedSkills.includes(label);

    return (
        <SkillBox2>
            <div>{label}</div>
            <IconButton
                color='#0044C6'
                onClick={() => onAdd(label)}
                className='flex-center p-0'
                disableTouchRipple
                disabled={isSkillSelected}
            >
                {isSkillSelected ? <AddCircleRoundedIcon className='color-blue' /> : <AddCircleRoundedIcon />}
            </IconButton>
        </SkillBox2>
    );
}

const SkillsAccordion = ({ sections, selectedSkills, handleAddSkill }) => {
    const [expanded, setExpanded] = useState(false);

    const handleAccordionChange = (section) => {
        setExpanded(expanded === section ? false : section);
    };

    return (
        <Grid container spacing={2}>
            {sections.map((section, index) => (
                <Grid item xs={12} key={index} className='AddSectionAccordians'>
                    <Accordion
                        expanded={expanded === section.title}
                        onChange={() => handleAccordionChange(section.title)}
                        className="custom-accordion ps-0"
                    >
                        <AccordionSummary expandIcon={expanded === section.title ? <OutlinedMinusIcon /> : <OutlinedPlusIcon />}>
                            <span>{section.title}</span>
                        </AccordionSummary>
                        <AccordionDetails>
                            <section className='soc-modal-section d-flex flex-wrap'>
                                {section?.skills?.map((skill, skillIndex) => (
                                    <SkillItem2 key={skill} label={skill} selectedSkills={selectedSkills} onAdd={handleAddSkill} />
                                ))}
                            </section>
                        </AccordionDetails>
                    </Accordion>
                </Grid>
            ))}
        </Grid>
    );
};


export function SkillItemForServices({ maxSize, updateAttachments }) {

    const [fileInputKey, setFileInputKey] = useState('');

    const [inputValue, setInputValue] = useState('');
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const { handleInfo, handleFailure } = useQuantityContext();
    const handleClose = (event) => {
        event.stopPropagation();
        setAnchorEl(null);
    };

    const handleAdd = (event) => {
        setInputValue('');
        handleClose(event);
    };

    const [AddLinkService, setAddLinkService] = useState(false);
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setFileInputKey(uuidv4());
            validateAndUploadFile(file);
        } else { }
    };

    const validateAndUploadFile = async (file) => {
        if (file) {
            if (file.size <= maxSize) {
                // const reader = new FileReader();
                // reader.onloadend = () => {
                //     const base64format = reader.result;
                //     const tempdata = base64format.split(",")[1];
                try {
                    // const formData = new FormData();
                    // formData.append('file', file);

                    // const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/uploadpublicblob/generate-sas-url`, formData, {
                    //     headers: {
                    //         'Content-Type': 'multipart/form-data',
                    //     },
                    // });

                    // const { url } = response.data;

                    const objectUrl = URL.createObjectURL(file)

                    const fileObject = {
                        name: file.name || 'file',
                        size: formatFileSize(file.size), // Ensure size is formatted
                        date: new Date().toLocaleDateString(), // Add date
                        type: getFileType(file.name),
                        data: objectUrl,
                    };

                    // console.log("INSIDE THE ADD SECTIONN", fileObject);
                    updateAttachments(fileObject);
                    // };
                    // reader.readAsDataURL(file);
                } catch (error) {
                    console.error('Error uploading file:', error);
                    handleFailure('Error uploading file. Please try again.');
                }
            } else {
                handleInfo(`File size must be ${formatFileSize(maxSize)} or less.`);
            }
        }
    };

    const getFileType = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();
        switch (extension) {
            case 'jpg':
            case 'jpeg':
                return 'image/jpeg';
            case 'png':
                return 'image/png';
            case 'gif':
                return 'image/gif';
            case 'mp4':
                return 'video/mp4';
            case 'mov':
                return 'video/quicktime';
            case 'avi':
                return 'video/x-msvideo';
            case 'mpg':
            case 'mpeg':
                return 'video/mpeg';
            case 'pdf':
                return 'application/pdf';
            case 'doc':
            case 'docx':
                return 'application/msword';
            case 'ppt':
            case 'pptx':
                return 'application/vnd.ms-powerpoint';
            case 'xls':
            case 'xlsx':
                return 'application/vnd.ms-excel';
            case 'onetoc':
            case 'onetoc2':
            case 'onetmp':
            case 'onepkg':
                return 'application/onenote';
            case 'gsheet':
                return 'application/vnd.google-apps.spreadsheet';
            case 'gdoc':
                return 'application/vnd.google-apps.document';
            default:
                return 'application/octet-stream';
        }
    };

    const formatFileSize = (size) => {
        if (size >= 1000000) {
            return `${(size / 1000000).toFixed(1)} Mb`;
        } else {
            return `${(size / 1000).toFixed(0)} Kb`;
        }
    };

    const [link, setLink] = useState('');
    const [linkName, setLinkName] = useState('');

    const handleSaveLink = (link, linkName) => {
        const fileObjectForLink = {
            name: linkName.trim() || link.trim() || 'Link',
            date: new Date().toLocaleDateString(), // Add date
            type: 'url',
            data: link.trim(),
        };
        setAddLinkService(false);
        updateAttachments(fileObjectForLink);
        setLink('');
        setLinkName('');
    }

    return (
        <>
            <SkillBox className='justify-content-start' onClick={handleClick}>
                <div>Upload</div>
                <IconButton
                    color='#0044C6'
                    onClick={handleClick}
                    className='flex-center p-0'
                >
                    <AddCircleRoundedIcon />
                </IconButton>
                <Popover
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    <List className='add-services-list'>
                        <ListItem button onClick={() => { document.getElementById('imageInput').click() }}>
                            <ListItemText primary='Add Image' secondary='Up to 5 MB' ></ListItemText>

                        </ListItem>
                        <input
                            type="file"
                            id="imageInput"
                            accept='image/*'
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                            key={fileInputKey + 'image'}
                        />


                        <ListItem button onClick={() => { document.getElementById('documentInput').click() }}>
                            <ListItemText primary='Add Document' secondary='Up to 5 MB' ></ListItemText>

                        </ListItem>
                        <input
                            type="file"
                            id="documentInput"
                            accept='application/pdf/*'
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                            key={fileInputKey + 'pdf'}
                        />
                        <ListItem button onClick={() => { document.getElementById('videoInput').click() }}>
                            <ListItemText primary='Add Video' secondary='Up to 5 MB' ></ListItemText>
                        </ListItem>
                        <input
                            type="file"
                            id="videoInput"
                            accept='video/*'
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                            key={fileInputKey + 'video'}
                        />
                        <ListItem button onClick={handleAdd}>
                            <ListItemText primary="Add Link" secondary='Links of videos, articles or websites' onClick={(event) => { setAddLinkService(true) }} />
                        </ListItem>
                        {/* Add other list items here as needed */}
                    </List>
                </Popover>
            </SkillBox>

            {AddLinkService &&
                <div className="lightbox-overlay">
                    <div className="lightbox-content py-4 px-0">
                        <>
                            <div className='profile-modal-title-content px-4'>
                                <IconButton className="modal-close-button p-0" onClick={() => setAddLinkService(false)}><CloseRoundedIcon /></IconButton>
                                <span className='profile-modal-heading1 text-left mb-1'>Add a Link</span>
                            </div>
                            <div className='px-4 pt-4'>
                                <TextField
                                    name="LinkName"
                                    label="Title"
                                    placeholder='Name for the link'
                                    required
                                    value={linkName}
                                    onChange={(e) => setLinkName(e.target.value)}
                                    InputLabelProps={{ required: false }}
                                    fullWidth
                                    className='modal-link-field mb-3'
                                />
                                <TextField
                                    name="Link"
                                    label="URL"
                                    placeholder='Paste or type a link to an article, file or video'
                                    required
                                    value={link}
                                    onChange={(e) => setLink(e.target.value)}
                                    InputLabelProps={{ required: false }}
                                    fullWidth
                                    className='modal-link-field'
                                />

                                <div className='d-flex justify-content-end mt-3'>
                                    {/* <button className='mx-2 pointer'>BACK</button> */}
                                    <Button variant='contained' sx={{ backgroundColor: '#0044C6' }} disabled={!link} onClick={() => handleSaveLink(link, linkName)}>Save</Button>
                                </div>
                            </div>
                        </>
                    </div>
                </div>
            }
        </>
    );
}

const CurrencyDropdown = ({ name, value, onChange }) => {
    const handleChange = event => {
        onChange({
            target: {
                name: name,
                value: event.target.value,
            }
        });
    };

    const options = currencyCodes.codes().map(code => {
        const currency = currencyCodes.code(code);
        return (
            <option key={code} value={code}>
                {`${currency.code}`}
            </option>
        );
    });

    return (
        <select onChange={handleChange} value={value} className="form-control currency-field">
            {options}
        </select>
    );
};

function SkillItem({ label, isEdit, onAdd }) {
    return (
        <SkillBox>
            <div className="skill-item">{label}</div>
            {isEdit &&
                <IconButton
                    color='color-lightred'
                    onClick={() => onAdd(label)}
                    className='flex-center delete-icon-skills'
                >
                    <CancelIcon color="color-lightred" className="delete-icon-skills" />
                </IconButton>
            }
        </SkillBox>
    );
}

const SkillBox = styled(Box)({
    border: "1px solid #D9D9D9",
    height: '32px',
    borderRadius: '16px',
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "6px 12px",
    margin: '6px 6px 6px 0px',
    gap: '5px',
    fontSize: '14px',
    lineHeight: '20.02px'
});

export default AddSection;

AddSection.defaultProps = {
    isServiceEditing: false
}
